import styled, { keyframes } from "styled-components";
export const Form = styled.form`
  flex-direction: column;
  flex: 1;
  position: relative;
  gap: 10px;
  &.popup {
    border: 1px solid rgb(224, 224, 227);
    padding: 1em;
    border-radius: 10px;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
  }
  &.plain {
    border-radius: 10px;
    display: flex;
  }
  &.contact {
    border: none;
  }
  &.signupForm {
    padding: 1em;
    border-radius: 10px;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
  }
  &.sub {
    flex: 100%;
    padding: 0;
    border: 0;
    border-radius: 0;
  }
  && {
    .single & {
      flex-direction: column;
    }
  }
  @media (max-width: 768px) {
    &.popup {
      border: 0;
    }
    &.signupForm {
      flex-direction: column;
    }
  }
`;
export const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

export const Overlay = styled.div`
  backdrop-filter: blur(5px);
  &.popup {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    padding: 25px 0;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba(0, 0, 0, 0.2);
    overflow: auto;
    z-index: 1001;
  }
  &.plain {
    box-shadow: rgb(0 0 0 / 16%) 0px 5px 9px 0px;
    padding: 20px;
    border-radius: 10px;
    background-color: white;
    margin: auto;
  }
  &.contact {
    position: static;
    background-color: #f2f4fa;
    color: #292358;
  }
  &.loginForm {
    padding: 50px 60px;
    @media screen and (max-width: 768px) {
      // padding: 20px;
      // margin: 0 auto;
      width: calc(100% - 40px);
      max-width: 400px;
    }
  }
  &.signupForm {
    padding: 50px 60px;
    margin: 0 auto;
    @media screen and (max-width: 768px) {
      // padding: 20px;
      // margin: 0 auto;
      width: calc(100% - 40px);
      max-width: 400px;
    }
  }
  @media (max-width: 768px) {
    &.popup {
      width: 100%;
      padding: 0;
      top: 0;
      bottom: 0;
      border-top: 1px solid rgb(224, 224, 227);
    }
    &.plain {
    padding: 20px;
    }
  }
`;
export const Page = styled.div`
  z-index: 1;
  &.popup {
    display: flex;
    flex-direction: column;
    display: flex;
    background-color: white;
    border-radius: 10px;
    width: 700px;
    min-width: 200px;
    max-width: 70%;
    height: auto;
    animation: ${fadeIn} 1s ease-in-out;
    animation-duration: 0.2s;
    margin: auto;
    padding: 1em;
  }
  &.full {
    display: flex;
    flex-direction: column;
    display: flex;
    background-color: white;
    border-radius: 10px;
    width: 60%;
    min-width: 200px;
    max-width: 70%;
    height: auto;
    animation: ${fadeIn} 1s ease-in-out;
    animation-duration: 0.2s;
    margin: auto;
    padding: 1em;
  }
  &.plain {
    min-width: 250px;
    width: 300px;
    max-width: 100%;
    @media screen and (max-width: 768px) {
      width: 100%;
    }
  }
  &.loginForm {
    min-width: 350px;
    @media screen and (max-width: 768px) {
      width: 100%;
      min-width: 0px;
    }
  }
  &.signupForm {
    min-width: 610px;
    max-width: 100%;
    // width: auto;
    @media screen and (max-width: 768px) {
      width: 100%;
      min-width: 0px;
    }
  }
  &.contact {
    width: auto;
    max-width: 768px;
    background-color: #B6D8EE;
    border: 2px solid #d6e0ff;
    // padding: 2em 3em;
    box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;
  }
  &.contact-head {
    width: auto;
    max-width: 100%;
    margin: 0;
    color: #292358;
    border: 2px solid #d6e0ff;
    // padding: 2em 5.5em;
    box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;
  }
  && {
    .single & {
      width: 450px;
    }
  }
  @media (max-width: 768px) {
    &.popup {
      width: 100%;
      position: relative;
      top: 0;
      padding: 0;
      max-width: 100%;
    }
    &.plain {
    }
    &.contact-head {
      width: calc(100% - 4px);
    }
  }
`;
export const LogoDiv = styled.div`
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 20px;
      &.loginForm{
        margin-bottom: 50px;
      }
      @media (max-width: 768px) {
        margin-bottom: 20px;
        &.loginForm{
          margin: 40px auto;
        }
      }
`;
export const Header = styled.div`
  text-align: left;
  padding: 0.5em 0 0.5em;
  font-weight: 600;
  font-size: 1.5em;
  &.popup {
    text-align: center;
  }
  && {
    .single & {
      color: black;
    }
  }
  &.signupForm {
    padding: 0.5em 16px;
    color: #292358;
  }
  &.contact {
    font-weight: 700;
    font-size: 2em;
    text-align: center;
  }
  &.loginForm {
    padding-bottom: 1em;
  }
  @media (max-width: 768px) {
    &.popup {
      position: sticky;
      padding: 1em 0 1em;
    }
    font-size: 18px;
    top: 0;
    background: white;
    z-index: 1;
    border-bottom: 1px solid rgb(224, 224, 227);
    &.contact {
      font-size: 1.5em;
      background: none;
      border: none;
    }
  }
`;
export const Footer = styled.div`
  display: flex;
  justify-content: flex-end;
  justify-content: center;
  margin-top: 10px;
  &.contact {
    margin-top: 0;
    padding-left: 1em;
  }
  &.left {
    justify-content: left;
  }
    
  @media (max-width: 768px) {
    position: sticky;
    bottom: 0;
    background: white;
    padding-bottom: 10px;
    border-top: 1px solid rgb(224, 224, 227);
  }
`;
export const ForgetPass = styled.div`
  text-align: center;
  margin-top: 10px;
  @media (max-width: 768px) {
    margin: 20px 0;
  }
`;
export const ErrorMessage = styled.div`
  padding-left: 0;
  margin: 5px 7px 8px;
  color: #fe7b7b;
  font-size: 12px;
  width: 100%;
`;
export const Description = styled.div`
  flex: 1 1 100%;
  margin: 10px 0;
  display: flex;
  && {
    .single & {
      color: black;
    }
  }
    &.signupForm{
      padding: 0 16px;
      color: #292358;
    }
  && {
    .popup & {
      margin: 0 0 10px;
      justify-content: center;
      text-align: justify;
      border: 1px solid rgb(224, 224, 227);
      border-radius: 10px;
      padding: 10px 20px;
      font-size: 14px;
      /* background-color: #e7f2f9; */
    }
  }

  @media (max-width: 768px) {
    && {
      .popup & {
        border: 0px solid rgb(224, 224, 227);
        background-color: #e7f2f9;
        border-radius: 10px;
        margin: 15px 15px 0px;
        padding: 10px;
      }
    }
  }
`;

export const Plus = styled.div`
  background: transparent;
  transition: 0.2s;
  &:hover {
    transform: scale(1.3);
  }
`;
export const ButtonContanter = styled.aside`
  position: relative;
  width: 100%;
  box-sizing: border-box;
  padding: 10px 10px;
  outline: none !important;
  width: 100%;
  border-radius: 10px;
  border: 0px solid Black;
  margin: 0 0px 10px 0;
  padding-left: 1em;
  font-weight: 700;
  box-shadow: none;
  -webkit-appearance: none;
  -webkit-transition: all 0.2s ease-out 0s;
  transition: all 0.2s ease-out 0s;
  color: #4f4f4f;
  background: #e7f2f9;
  text-align: center;
  transition: 0.5s;
  &.close {
    position: absolute;
    right: 10px;
    top: 15px;
    background: transparent;
    width: 25px;
    height: 20px;
    padding: 1px;
    color: black;
  }
  button {
    transition: 0.5s;
    background-color: transparent;
    border: 0;
    display: flex;
    flex-direction: column;
    margin: auto;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    svg {
      font-size: 20px;
      margin-bottom: 15px;
    }
  }
`;

export const Logo = styled.img`
  min-height: auto;
  width: auto;
  padding-left: 0.5em;
  padding-top: 0.5em;
  margin-bottom: 10px;
  max-width: 220px !important;
  && {
    .small & {
      /* visibility: hidden; */
    }
  }
  @media screen and (max-width: 768px) {
    height: 20px;
    max-width: 150px;
    &.menu {
      padding: 0;
    }
    &.loginForm {
      height: auto;
    }
  }
`;
